<template>
  <div class="card shadow mt-2 mb-3 border-0">
    <div class="card-body">
      <div class="title">
        <div class="wrap">
          <h5>Настройки отчётов</h5>
          <div class="sub-title">Добавьте группы ссылок, чтобы структурировать информацию в отчёте</div>
        </div>
        <button class="btn btn-primary ms-auto btn-sm" @click.prevent="addGroup">
          <i class="bi bi-plus-lg"></i> Добавить группу
        </button>
      </div>
      <ul class="list-unstyled links groups">
        <li v-for="(group, index) in groups" :key="group.id || index">
          <div class="link">
            <template v-if="group.edit">
              <input class="form-control" placeholder="Введите название группы" style="width: 100%" type="text"
                     v-model="group.name">
            </template>
            <template v-else>
              {{ group.name }}
            </template>
          </div>
          <div class="buttons ms-auto">
            <div class="col">
              <template v-if="!group.edit">
                <div class="buttons">
                  <a href="" class="text-primary" title="Редактировать" @click.prevent="group.edit=true">
                    <i class="bi bi-pencil"></i>
                  </a>
                  <a href="" class="text-danger" title="Удалить" @click.prevent="deleteObj= {g: group, i: index};$modal('show', 'delete_group')">
                    <i class="bi bi-trash3"></i>
                  </a>
                </div>
              </template>
              <template v-else>
                <div class="buttons">
                  <button class="btn btn-sm btn-outline-success" title="Сохранить"
                          @click.prevent="saveGroup(group, index)">
                    <i class="bi bi-check-lg"></i> Сохранить
                  </button>
                  <button class="btn btn-sm btn-outline-secondary" title="Отмена"
                          @click.prevent="cancelEdit(group, index)">
                    <i class="bi bi-x-lg"></i> Отмена
                  </button>
                </div>
              </template>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <modal modal_id="delete_group">
        <template v-slot:header>
          <h4>Удаление группы</h4>
        </template>
        <template v-slot:body>

          <h6>Вы уверены, что хотите удалить группу "{{deleteObj?.g?.name}}"?</h6>

        </template>
        <template v-slot:footer>
          <button type="button" class="btn btn-secondary" @click="$modal('hide', 'delete_group')"
                  data-bs-dismiss="modal">Закрыть
          </button>
          <button type="button" class="btn btn-danger" @click="deleteGroup(deleteObj.g, deleteObj.i)"
                  data-bs-dismiss="modal">Удалить
          </button>
        </template>
      </modal>
  </div>
</template>

<script>
import { LinksApi } from "@/api/links";

export default {
  name: 'ReportGroupsSettings',
  props: {
    projectId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      groups: [],
      deleteObj: {}
    }
  },
  computed: {
    currentProjectId() {
      return this.$store.getters.currentProjectId
    }
  },
  mounted() {
    this.loadGroups();
  },
  methods: {
    loadGroups() {
      LinksApi.review_group_list().then(response => {
        this.groups = response;
        this.$emit('update:groups', this.groups);
      });
    },
    addGroup() {
      this.groups.push({ name: '', edit: true });
    },
    saveGroup(group, index) {
      group.project_id = this.projectId || this.currentProjectId;
      LinksApi.review_group_create(group).then(response => {
        this.groups.splice(index, 1, response);
        this.$emit('update:groups', this.groups);
      });
    },
    deleteGroup(group, index) {
      group.project_id = this.projectId || this.currentProjectId;
      LinksApi.review_group_delete(group).then(response => {
        this.groups.splice(index, 1);
        this.$emit('update:groups', this.groups);
        this.$modal('hide', 'delete_group');
      });
    },
    cancelEdit(group, index) {
      if (group.id) {
        group.edit = false;
      } else {
        this.groups.splice(index, 1);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.links.groups {
  display: block;
  column-count: 2;

  li {
    display: flex;
    gap: 20px;
    white-space: nowrap;
    flex-wrap: nowrap;
    margin-bottom: 10px;
    break-inside: avoid-column;

    .link {
      width: 100%;
      height: 35px;
      display: flex;
      align-items: center;

      input {
        width: 100%;
      }
    }

    .buttons {
      display: flex;
      gap: 10px;
    }
  }
}

@media (width < 768px) {
  .links.groups {
    column-count: 1;
  }
}
</style>